function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'ash-brown': 'rgb(121, 104, 88)','olive-green': 'rgb(133, 133, 101)','slate-grey': 'rgb(75, 77, 83)','blaze-orange': 'rgb(231, 86, 40)','military-green': 'rgb(97, 91, 73)','heather-navy': 'rgb(80, 82, 97)','deep-navy': 'rgb(24, 35, 54)','sand': 'rgb(212, 196, 168)','bronze': 'rgb(170, 113, 75)','forest-green': 'rgb(35, 55, 46)','charcoal': 'rgb(80, 79, 77)','stone-grey': 'rgb(167, 167, 165)','navy': 'rgb(47, 48, 54)','indigo': 'rgb(96, 108, 127)','espresso': 'rgb(124, 106, 101)','dark-heather': 'rgb(109, 109, 107)','gunmetal-heather': 'rgb(152, 151, 161)','sandstone': 'rgb(193, 157, 125)','cement': 'rgb(182, 174, 166)',};

    this.images = {'summit': 'url("//skregear.co.nz/cdn/shop/files/Summit-Swatch_68x.jpg?v=5069210203092557390")','solace': 'url("//skregear.co.nz/cdn/shop/files/Solace-Swatch_68x.jpg?v=518678621640638907")','carbon': 'url("//skregear.co.nz/cdn/shop/files/Carbon-Swatch2_68x.jpg?v=16300675003022699959")','blue-white': 'url("//skregear.co.nz/cdn/shop/files/Blue-White-Swatch_68x.jpg?v=10666718784003939515")','brown-gold': 'url("//skregear.co.nz/cdn/shop/files/Brown-Gold-Swatch_68x.jpg?v=3587606526269582009")','green-gold': 'url("//skregear.co.nz/cdn/shop/files/Green-Gold-Swatch_68x.jpg?v=14274989670911113635")','grey-white': 'url("//skregear.co.nz/cdn/shop/files/Grey-White-Swatch_68x.jpg?v=8358837321602884535")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
